((app, ng) => {

    //app.component("banner",
    //    {
    //        templateUrl: '/App/Services/Banner/banner.template.html',
    //        controller: bannerController,
    //        bindings: {
    //            message: '<'
    //        }
    //    });

    app.directive('banner', () => {
        return {
            restrict: 'E',
            scope: {
                message: '=message',
                close: '&onClose'
            },
            templateUrl: '/App/Services/Banner/banner.template.html',
            //controller: ['$scope', function bannerController($scope) {
            //    $scope.close = () => {
            //        console.log('dismissed');
            //    };
            //}]
        }
    });

    //const bannerController = () => {
    //    const $ctrl = this;
    //    ng.extend($ctrl, {
    //        bannerMessage: 'Be on the lookout for a new dashboard coming soon!'
    //    })

    //    $ctrl.dismiss = () => {

    //    };
    //}

})(window.app, window.angular);